import { defineComponent as _defineComponent } from 'vue'
import {
  formatDate,
  linkageSelectTree,
  LinkageTree,
  getLinkageOptionLocal,
  inRevise
} from '@/utils'
import {
  watchEffect,
  ref,
  UnwrapRef,
  Ref,
  ComputedRef,
  computed,
  watch,
  onActivated
} from 'vue'
import { DataSetAtom } from '@/store/dataset'
import { ModelRaw, ModelDatasetAtom, ModelAtom } from '@/store/model'
import { icons } from './constant'
import TreeAtom from '@/components/tree-atom/index.vue'
import { customMap } from '@/hook'
import { Mode } from '@/sdk'
import { ui18n } from '@/lang'

type Tree = UnwrapRef<LinkageTree<DataSetAtom>>
type Trees = Array<Tree>


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    joinSelect: { type: Boolean, required: false, default: false },
    list: { type: Array, required: true },
    selects: { type: Array, required: true },
    customs: { type: Array, required: false },
    highlight: { type: Array, required: false },
    search: { type: Boolean, required: false },
    border: { type: Boolean, required: false },
    title: { type: String, required: false, default: ui18n.t('dataset.title') },
    disabledSelect: { type: Boolean, required: false }
  },
  emits: ["selects", "search", "click"],
  setup(__props: any, { expose: __expose, emit }) {
  __expose();

const props = __props;



const key = ref(0)
let inUpdate = false
watch(
  () => props.list,
  (a, b) => {
    if (a !== b) {
      inUpdate = true
    }
  }
)

onActivated(() => {
  if (inUpdate) {
    setTimeout(() => {
      key.value++
    }, 16)
  }
})



const updateSelectTrees = (selectTrees: Trees) => {
  for (const linkage of selectTrees) {
    linkage.selects = linkage.options.filter((option: any) =>
      props.selects.includes(option)
    )
  }
}

const selectTrees = ref<Trees>()
watchEffect(() => {
  selectTrees.value = (props.list as any).map(item =>
    linkageSelectTree(item, false)
  )
})
watchEffect(() => updateSelectTrees(selectTrees.value))
// watchEffect(() => {
//     if (selectTrees.value) {
//         const selects = selectTrees.value.reduce((p, item) => [...p, ...item.selects], [])
//     }
// })

const getTreeSelect = (locals: number[]) => {
  let currentTree = selectTrees.value
  let tree: Tree = null
  for (const index of locals) {
    tree = currentTree[index]
    currentTree = tree.children
  }
  return tree
}

watchEffect(
  () => {
    const selects = []
    for (const tree of selectTrees.value) {
      selects.push(...tree.selects)
    }
    if (inRevise(props.selects, selects)) {
      emit('selects', selects)
    }
  },
  { flush: 'post' }
)

let searchData: Ref<ModelDatasetAtom>
let options: ComputedRef<
  Array<{
    value: ModelDatasetAtom
    label: ModelDatasetAtom['title']
  }>
>

if (props.search) {
  searchData = ref<ModelDatasetAtom>()
  options = computed(() =>
    selectTrees.value
      .reduce((t, c) => [...t, ...c.options], [])
      .map(item => ({ value: item, label: item.title || item.origin.title }))
  )

  let old
  watchEffect(() => {
    if (old !== searchData.value) {
      emit('search', searchData.value)
      old = searchData.value
    }
  })

  watchEffect(() => {
    if (!props.highlight.includes(searchData.value)) {
      searchData.value = undefined
    }
  })
}

const __returned__ = { props, key, get inUpdate() { return inUpdate }, set inUpdate(v) { inUpdate = v }, emit, updateSelectTrees, selectTrees, getTreeSelect, get searchData() { return searchData }, set searchData(v) { searchData = v }, get options() { return options }, set options(v) { options = v }, get icons() { return icons }, TreeAtom, get customMap() { return customMap }, get Mode() { return Mode } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})